import React from "react";

import { IViewProps, View } from "core/decorators/View";
import SeparatorViewConfig from "./SeparatorViewConfig";



@View({id: "separator", configClass: SeparatorViewConfig})
export class SeparatorView extends React.Component<IViewProps<SeparatorViewConfig>> {

	// TODO make nice
	public render() {
		const { spacing, height, width } = this.props.config;
		return <div style={{height: height || spacing + "px", width}}></div>;
	}
}



// WEBPACK FOOTER //
// ./src/common/views/separator/Separator.view.tsx